module.exports = __webpack_public_path__ + "assets/img/a2.94598d98.jpg";